<template>
  <modal
    name="create-daily-answers"
    transition="pop-out"
    :classes="'modal fade show'"
    :height="modalHeight"
    :resizable="false"
    :pivot-y="0.05"
    @before-open="beforeOpen"
  >
    <div class="modal-dialog ui-block window-popup create-event">
      <a
        href="#"
        class="close icon-close"
        aria-label="Close"
        @click="$modal.hide('create-daily-answers')"
      >
        <app-icon
          name="olymp-close-icon"
          color="black"
          size="small"
        />
      </a>
      <!--<flash-message class="fl-msg"></flash-message>-->
      <div class="fl-msg" />

      <div
        v-if="date"
        class="ui-block-title"
      >
        <h6 class="title">
          Answer to Questions related to {{ date | formatDate('MM/dd/yyyy') }}
        </h6>
      </div>

      <ol v-if="questions && questions.length">
        <li
          v-for="quest in questions"
          :key="quest.id"
          class="padding10"
        >
          {{ quest.title }}
        </li>
      </ol>

      <div class="ui-block-content">
        <form
          class="content"
          @submit.prevent="addAnswer"
        >
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
              <div class="form-group label-floating">
                <label class="control-label">Answer</label>
                <wysiwyg v-model="item.description" />
              </div>
            </div>
          </div>
          <button
            class="btn btn-lg btn-breez full-width"
            type="submit"
            name="submit"
          >
            <span>Add Answer</span>
          </button>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import VModal from 'vue-js-modal';
import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg'
import '../../../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
Vue.use(VModal, {dialog: true});

Vue.use(wysiwyg, {
  // { [module]: boolean (set true to hide) }
  hideModules: {
    bold: false,
    italic: false,
    underline: false,
    justifyLeft: true,
    justifyCenter: true,
    justifyRight: true,
    headings: true,
    link: false,
    code: false,
    orderedList: true,
    unorderedList: true,
    image: false,
    table: true
  },
  // image: {
  //   uploadURL: IMAGE_URL,
  //   dropzoneOptions: {}
  // },
  forcePlainTextOnPaste: true
})

const MODAL_HEIGHT = 800

import AppIcon from "../../common-apps/common/AppIcon"

export default {
  name: 'AddDailyAnswers',
  components: { AppIcon },
  data () {
    return {
      modalHeight: MODAL_HEIGHT,
      date: new Date(),
      item: {
        description: '',
        question_id: 1
      }
    }
  },
  computed: mapState({
    questions: state => state.dailyAnswers ? state.dailyAnswers.questions :[]
  }),
  created () {
    this.modalHeight = window.innerHeight < MODAL_HEIGHT
      ? MODAL_HEIGHT - 200
      : MODAL_HEIGHT
  },
  methods: {
    beforeOpen (event) {
      this.date = event.params.date
      this.$store.dispatch('dailyAnswers/getQuestions')
    },
    // eslint-disable-next-line
      addAnswer: function() { // !!!! this messes up if I use arrow function
      const payload = []
      // console.log(this.date.format('YYYY-MM-DDTHH:mm:ss.SSS'));
      // console.log(moment.utc(this.date).format('YYYY-MM-DDTHH:mm:ss.SSS'));

        let day = format(this.date, 'dd');
        let month = format(this.date, 'MM');
        let year = format(this.date, 'yyyy');
        /*const payload = Object.assign({
          date: new Date(`${year}-${month}-${day}T10:00:01`)
        }, this.item)*/
      if (this.item.description.length) {
        payload.push(Object.assign({
          date: new Date(`${year}-${month}-${day}T10:00:01`)
        }, this.item))
      }
      this.$store.dispatch('dailyAnswers/addBulk', payload)
    }
  }
}
</script>
